import React, { useState, useEffect } from "react";
import Modal from "../../layouts/Modal/Modal";
import { Link } from "react-router-dom";
import ButtonComponent from "../../Styles/Form/ButtonComponent";
import InputComponent from "../../Styles/Form/InputComponent";
import Loading from "../../layouts/Loading/Loading";
import axios from "axios";
function ManagmentCarpet() {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [newCarpet, setNewCarpet] = useState({});
  const [editCarpet, setEditeCarpet] = useState({});
  const [allCarpet, setAllCarpet] = useState(null);
  const editeCarpetHandler = () => {
    axios
      .put(
        `https://carpet.bistatechnology.ir/api/v1/admin/carpet/${selectedItem.id}`,
        editCarpet
      )
      .then((res) => {
        console.log(res);
        getAllCarpet();
        alert("ویرایش انجام شد");
      })
      .catch(() => {
        alert("خطا");
      })
      .finally(() => {
        setShowEditModal(false);
        setSelectedItem(null);
        setEditeCarpet(null);
      });
  };

  const getAllCarpet = () => {
    axios
      .get("https://carpet.bistatechnology.ir/api/v1/admin/carpet")
      .then((res) => {
        setAllCarpet(res.data);
      })
      .catch(() => {
        alert("خطا در دریافت اطلاعات");
      });
  };

  const deleteCarpetHandler = () => {
    axios
      .delete(
        `https://carpet.bistatechnology.ir/api/v1/admin/carpet/${selectedItem.id}`
      )
      .then((res) => {
        console.log(res);
        getAllCarpet();
        setShowAddModal(false);
        alert("حذف شد");
      })
      .catch(() => {
        alert("خطا");
      })
      .finally(() => {
        setSelectedItem(null);
      });
  };

  useEffect(() => {
    getAllCarpet();
  }, []);

  const handleSelectRow = (item) => {
    setSelectedItem(item);
  };

  const deleteItemHandler = () => {
    if (window.confirm(` آیا فرش "${selectedItem.code}" حذف گردد؟`)) {
      deleteCarpetHandler();
    }
  };

  const changeEditeHandler = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setEditeCarpet({ ...editCarpet, [name]: value });
  };
  const CreateCarpetHandler = () => {
    axios
      .post(`https://carpet.bistatechnology.ir/api/v1/admin/carpet`, newCarpet)
      .then((res) => {
        console.log(res);
        alert("ثبت موفق", "فرش جدید با موفقیت ثبت شد");
        setShowAddModal(false)
        newCarpet(null);
      })
      .catch((err) => {
        console.log(err.response.status);
        alert("خطا", "    ثبت نشد", "error");
      });
  };
  const changeInputHandler = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setNewCarpet({ ...newCarpet, [name]: value });
  };
  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">لیست فرش ها</h5>
        {showAddModal && (
          <Modal>
            <div className="d-flex flex-row flex-wrap">
              <InputComponent
                inputName="category_id"
                inputId="category_id"
                lableValue="ایدی دسته بندی"
                onChange={(e) => changeInputHandler(e)}
              />
              {/* <InputComponent
              inputName="image"
              inputId="image"
              lableValue="سریال شناسنامه"
              onChange={(e) => changeEditeHandler(e)}
              defaultValue={selectedItem.certificate_serial}
            /> */}
              <InputComponent
                inputName="name"
                inputId="name"
                lableValue="نام فرش:"
                onChange={(e) => changeInputHandler(e)}
              />
              <InputComponent
                inputName="code"
                inputId="code"
                lableValue="کد فرش"
                onChange={(e) => changeInputHandler(e)}
              />
              <InputComponent
                inputName="color"
                inputId="color"
                lableValue="رنگ فرش"
                onChange={(e) => changeInputHandler(e)}
              />
              <InputComponent
                inputName="price"
                inputId="price"
                lableValue="قیمت فرش:"
                onChange={(e) => changeInputHandler(e)}
              />
              <InputComponent
                inputName="discount"
                inputId="discount"
                lableValue="مقدار تخفیف:"
                onChange={(e) => changeInputHandler(e)}
              />
              <InputComponent
                inputName="comb"
                inputId="comb"
                lableValue="شانه:"
                onChange={(e) => changeInputHandler(e)}
              />
              <InputComponent
                inputName="inventory"
                inputId="inventory"
                lableValue="موجودی:"
                onChange={(e) => changeInputHandler(e)}
              />
              <InputComponent
                inputName="dimensions"
                inputId="dimensions"
                lableValue="ابعاد"
                onChange={(e) => changeInputHandler(e)}
              />
              <InputComponent
                inputName="description"
                inputId="description"
                lableValue="توضیحات"
                onChange={(e) => changeInputHandler(e)}
              />
              <ButtonComponent
                value="ثبت"
                onClick={() => CreateCarpetHandler()}
              />
              <ButtonComponent
                value="لغو"
                onClick={() => setShowAddModal(false)}
              />
            </div>
          </Modal>
        )}
        {showEditModal && (
          <Modal>
            <div className="d-flex flex-row flex-wrap">
              <InputComponent
                inputName="category_id"
                inputId="category_id"
                lableValue="ایدی دسته بندی"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.category_id}
              />
              {/* <InputComponent
              inputName="image"
              inputId="image"
              lableValue="سریال شناسنامه"
              onChange={(e) => changeEditeHandler(e)}
              defaultValue={selectedItem.certificate_serial}
            /> */}
              <InputComponent
                inputName="name"
                inputId="name"
                lableValue="نام فرش:"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.name}
              />
              <InputComponent
                inputName="price"
                inputId="price"
                lableValue="قیمت فرش:"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.price}
              />
              <InputComponent
                inputName="discount"
                inputId="discount"
                lableValue="مقدار تخفیف:"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.discount}
              />
              <InputComponent
                inputName="comb"
                inputId="comb"
                lableValue="شانه:"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.comb}
              />
              <InputComponent
                inputName="inventory"
                inputId="inventory"
                lableValue="موجودی:"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.inventory}
              />
              <InputComponent
                inputName="code"
                inputId="code"
                lableValue="کد فرش"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.code}
              />
              <InputComponent
                inputName="color"
                inputId="color"
                lableValue="رنگ فرش"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.color}
              />
              <InputComponent
                inputName="dimensions"
                inputId="dimensions"
                lableValue="ابعاد"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.dimensions}
              />
              <InputComponent
                inputName="description"
                inputId="description"
                lableValue="توضیحات"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.description}
              />
              <ButtonComponent
                value="ثبت"
                onClick={() => editeCarpetHandler()}
              />
              <ButtonComponent
                value="لغو"
                onClick={() => setShowEditModal(false)}
              />
            </div>
          </Modal>
        )}
        <div className="d-flex flex-row ">
          <button
            className="bi-custom-button"
            onClick={() => setShowAddModal(true)}
          >
            اضافه کردن
          </button>
          <button
            className="bi-custom-button"
            onClick={() =>
              selectedItem
                ? setShowEditModal(true)
                : alert("جهت ویرایش یک آیتم را انتخاب کنید!")
            }
          >
            ویرایش
          </button>
          <button
            className="bi-custom-button"
            onClick={() =>
              selectedItem
                ? deleteItemHandler()
                : alert("جهت حذف یک آیتم را انتخاب کنید!")
            }
          >
            حذف
          </button>
        </div>
        {allCarpet === null ? (
          <Loading />
        ) : (
          <table className="bi-table-style bi-row-select-enable col-12 col-md-6 col-lg-4">
            <thead>
              <tr>
                <th> ایدی دسته بندی</th>
                {/* <th>عکس </th> */}
                <th>نام فرش</th>
                <th>کد فرش</th>
                <th>رنگ فرش</th>
                <th>ابعاد فرش</th>
                <th>قیمت فرش</th>
                <th>(درصد)مقدار تخفیف</th>
                <th>قیمت نهایی</th>
                <th>شانه</th>
                <th>موجودی</th>
                <th>توضیحات</th>
              </tr>
            </thead>
            <tbody>
              {allCarpet.map((Carpet, index) => {
                return (
                  <tr
                    id={Carpet.id}
                    onClick={() => handleSelectRow(Carpet)}
                    className={
                      selectedItem?.id === Carpet.id ? "item-slected" : null
                    }
                  >
                    <td>{Carpet.category_id}</td>
                    {/* <td>{Certificate.image}</td> */}
                    <td>{Carpet.name}</td>
                    <td>{Carpet.code}</td>
                    <td>{Carpet.color}</td>
                    <td>{Carpet.dimensions}</td>
                    <td>{Carpet.price}</td>
                    <td>{Carpet.discount}</td>
                    <td>{Carpet.final_price}</td>
                    <td>{Carpet.comb}</td>
                    <td>{Carpet.inventory}</td>
                    <td>{Carpet.description}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default ManagmentCarpet;
